import { createFileRoute } from '@tanstack/react-router';

import { ConversationPage, prefetchConversation } from '@/features/conversations';

export const Route = createFileRoute('/_authed/_active/s/$storeId/inbox/$conversationId')({
  loader: async ({ context, params }) => ({
    crumb: await prefetchConversation(context.queryClient, params.storeId, params.conversationId),
  }),
  component: ConversationPage,
});
